module.exports = __webpack_public_path__ + "static/images/imperial.76260c44cf052da6ae4f8d08683e1802.jpg";